export const blockIconsSearchChairAlt = (
	<span className='material-symbols-outlined'>chair_alt</span>
);
